import { useState, useEffect } from "react";
import { Box, Skeleton, Avatar, Typography, Container } from "@mui/material";
import CardsScrollableContainer from "../../components/CardsScrollableContainer";
import CardButton from "../../components/CardButton";
import { useGetRequests, usePutRequests } from "../../utils/queries";
import {
  connectionsApiUrl,
  protocol,
  hostname,
} from "../../utils/config";
import { useTranslation } from "react-i18next";
import RequestsDialog from "../../components/Dialog/RequestsDialog";
import { dialogActions } from "../../store/reducers/dialog";
import { useDispatch, useSelector } from "react-redux";
import { RequestsToken, homeToken } from "../../utils/constant";
import CircularLoader from "../../components/CircularLoader";
import RequestsAcceptDialog from "../../components/Dialog/RequestsAcceptDialog";
import { authHeaders, getSessionFromStorage } from "../../utils/session";
import { useTheme } from "@mui/material";
import ScrollContainerWrapper from "../../components/ScrollContainerWrapper";

const ReceivedRequestsSkelton = () => (
  <>
    {[...Array(12)].map((_, i) => {
      return (
        <Skeleton
          sx={{ width: "35.6rem", height: "15.8rem" }}
          variant="rectangular"
          key={i}
        />
      );
    })}
  </>
);
// =====received req card
const Card = ({
  cardData,
  handleSetIsRequestAccept,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();

  const {profileImage,
    name,
    profession,
    secondaryCategory,
    requiredSpeciality,
    chapterName,
    connectionUser} = cardData;



  const handleAcceptBtn = () => {
    dispatch(dialogActions.setDialogType("acceptrequest"));
    dispatch(dialogActions.setRequestId(connectionUser));
    dispatch(dialogActions.setDataObj(cardData));
    handleSetIsRequestAccept();
    return;
  };

  const handleRejectBtn = () => {
    dispatch(dialogActions.setDialogType("rejectrequest"));
    dispatch(dialogActions.setRequestId(connectionUser));
    return;
  };

  const handleIgnoreBtn = () => {
    dispatch(dialogActions.setDialogType("ignorerequest"));
    dispatch(dialogActions.setRequestId(connectionUser));
    return;
  };

  return (
    <Box
      sx={{
        width: "35.6rem",
        height: "15.8rem",
        backgroundColor: "#F2F2F2",
        display: "flex",
        flexDirection: "column",
        padding: "2.5rem 2.3rem",
        rowGap: "0.9rem",
        borderRadius: "0.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          columnGap: "2rem",
          width: "100%",
        }}
      >
        <Box
          sx={{ width: "7.8rem", display: "flex", justifyContent: "center" }}
        >
          <Avatar
            alt={`${name} profile image`}
            src={profileImage?`${protocol}${hostname}:443//core-api/public/image/${profileImage}`:`${name}`}
            sx={{ width: "6.5rem", height: "6.5rem" }}
          />
        </Box>
        <Box
          sx={{
            width: "21rem",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography
            title={name ? `${name}` : " "}
            sx={{
              fontSize: "2rem",
              color: "#cf2030",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              cursor: "default",
              lineHeight: "normal",
              whiteSpace:"nowrap"
            }}
          >
            {name ? `${name}` : ""`${name}`}
          </Typography>
          <Typography
          title={[profession, secondaryCategory, requiredSpeciality].filter(Boolean).join(" | ")}
          sx={{
            fontSize: "1.4rem",
            color: "#676767",
            textAlign: theme.direction === "rtl" ? "right" : "left",
            cursor: "default",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,    
            WebkitBoxOrient: "vertical",
            lineHeight: "normal",
            whiteSpace: "normal",  
            textWrap: "wrap",   
            margin: "0.2rem" ,    
          }}
        >
          {[profession, secondaryCategory, requiredSpeciality].filter(Boolean).join(" | ") || "\u00A0"}
        </Typography>
          <Typography
            sx={{
              fontSize: "1.4rem",
              color: "#cf2030",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              cursor: "default",
              lineHeight: "normal",
            }}
          >
            {`${chapterName ? chapterName : "\u00A0"}`}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          columnGap: "2rem",
          width: "100%",
        }}
      >
        <Box>
          <CardButton
            value={t(RequestsToken.Accept)}
            onClickHandler={handleAcceptBtn}
          />
        </Box>
        <Box sx={{ width: "21rem", display: "flex", columnGap: "1.2rem" }}>
          <CardButton
            btntype={"outlined"}
            value={t(RequestsToken.Reject)}
            onClickHandler={handleRejectBtn}
          />
          <CardButton
            btntype={"outlined"}
            value={t(RequestsToken.Ignore)}
            onClickHandler={handleIgnoreBtn}
          />
        </Box>
      </Box>
    </Box>
  );
};
// =====received req card

const ReceivedRequests = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const requestId = useSelector((state) => state.dialog.requestId);
  const getReceivedRequests = useGetRequests();
  const respondToReceivedRequest = usePutRequests();
  const [receivedRequestsData, setreceivedRequestsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMakeCall, setIsMakeCall] = useState(false);
  const [isRequestAccept, setIsRequestAccept] = useState(false);

  const requestHandler = () => {
    setIsLoading(true);
    setIsMakeCall(false);
    if (dialogType !== "acceptrequest") {
      dispatch(dialogActions.setIsDialogEnabled(false));
      dispatch(dialogActions.setDialogType(""));
      dispatch(dialogActions.setDataObj({}));
      dispatch(dialogActions.setRequestId(0));
    }
    if (requestId !== 0) {
      respondToReceivedRequest.mutate(
        {
          url: `${connectionsApiUrl}${requestId}`,
          data: {
            status:
              dialogType === "rejectrequest"
                ? "reject"
                : dialogType === "ignorerequest"
                ? "ignore"
                : "accept",
          },
        },
        {
          mutationKey: "rejectOrIgnoreRequest",
          onSuccess: (success) => {
            if (success.status === 200) {
              setIsLoading(false);
              if (dialogType !== "acceptrequest") {
                setIsMakeCall(true);
              } else if (dialogType === "acceptrequest") {
                dispatch(dialogActions.setIsDialogEnabled(true));
                dispatch(dialogActions.setDialogType("acceptrequest"));
                setIsRequestAccept(false);
                setIsMakeCall(true);
              }
            }
          },
          onError: (error) => {
            console.log(" request rejectOrIgnoreRequest failed ", error);
            setIsLoading(false);
            alert(t(homeToken.GenericError));
          },
        }
      );
    } else {
      alert("Invalid delete id");
    }
  };

  const handleSetIsRequestAccept = () => {
    setIsRequestAccept(true);
  };

  useEffect(() => {
    setIsMakeCall(true);
  }, []);
  
  useEffect(() => {
    if (isRequestAccept) {
      requestHandler();
    }
  }, [isRequestAccept]);

  useEffect(() => {
    if (isMakeCall) {
      getReceivedRequests.mutate(
        {
          url: `${connectionsApiUrl}received-requests`,
        },
        {
          mutationKey: "receivedRequestsData",
          onSuccess: (success) => {
            if (success.status === 200) {
              setreceivedRequestsData(success.data.content);
            }
          },
          onError: (error) => {
            console.log(" api call error data is ", error);
            alert(t(homeToken.GenericError));
          },
        }
      );
    }
  }, [isMakeCall]);

  return (
    <>
    <ScrollContainerWrapper>
    <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}>
      <CardsScrollableContainer marginTop={"true"} calcHeight="92vh">
        {getReceivedRequests.isLoading ? (
          <ReceivedRequestsSkelton />
        ) : getReceivedRequests.isSuccess &&
          receivedRequestsData.length >= 1 ? (
          <>
            {receivedRequestsData.map((req) => (
              <Card
                key={req.connectionUser}
                cardData={req}
                handleSetIsRequestAccept={handleSetIsRequestAccept}
              />
            ))}
          </>
        ) : (
          <>
            <Typography
            sx={{
              width:"100%",
              color: "#cf2030",
              textAlign: "center",
              fontWeight:"700",
              animation: "fadeanimation 2s infinite",
              gridColumn:"1/-1",
            }}
            >{t(homeToken.DataNotFound)}</Typography>
          </>
        )}
      </CardsScrollableContainer>
      {(dialogType === "rejectrequest" || dialogType === "ignorerequest") && (
        <Container maxWidth="false" disableGutters>
          <RequestsDialog
            dialogTitle={
              dialogType === "rejectrequest"
                ? t(RequestsToken.RejectRequestDialogTitle)
                : t(RequestsToken.IgnoreRequestDialogTitle)
            }
            dialogContent={
              dialogType === "rejectrequest"
                ? t(RequestsToken.RejectRequestDialogMessage)
                : t(RequestsToken.IgnoreRequestDialogMessage)
            }
            leftBtnVal={
              dialogType === "rejectrequest"
                ? t(RequestsToken.Reject)
                : t(RequestsToken.Ignore)
            }
            rightBtnVal={t(homeToken.Cancel)}
            leftbuttonHandler={requestHandler}
          />
        </Container>
      )}
      {dialogType === "acceptrequest" && (
        <Container maxWidth="false" disableGutters>
          <RequestsAcceptDialog
            dialogTitle={t(RequestsToken.NewConnectionDialogTitle)}
            dialogContentBtn={t(homeToken.ClickHere)}
            dialogContentRight={t(RequestsToken.AcceptRequestDialogSuccessRight)}
          />
        </Container>
      )}
      {isLoading && <CircularLoader />}
      </Box>
      </ScrollContainerWrapper>
    </>
  );
};
export default ReceivedRequests;
